export default {"src":"/_next/static/media/coffeescript.c4e09c86.svg","height":206,"width":256,"blurWidth":0,"blurHeight":0};